import { createContext } from 'react';
import { IHelloBar } from '../../../types/IHelloBar';

export type HelloBarContextValue = IHelloBar | null;

export const HelloBarContext = createContext<IHelloBar | null>(null);
